// Flow types automatically removed

import formStyles from './styles/FormGeneral.scss';
export const Banner = props => {
    let previousPageClass;
    let nextPageClass;

    if (props.page === 'page1') {
        previousPageClass = formStyles.activePage;
        nextPageClass = formStyles.inactivePage;
    } else {
        previousPageClass = formStyles.inactivePage;
        nextPageClass = formStyles.activePage;
    }

    return (
        <div className={formStyles.item}>
            <div className={formStyles.bannerDiv} id="jsScrollTargetHeader">
                <div className={formStyles.bannerHeader}>
                    {props.header}
                    <div className={formStyles.pageIndicator}>
                        <div className={previousPageClass} />
                        <div className={nextPageClass} />
                    </div>
                </div>
                <div className={props.classNames}>{props.subheader}</div>
                {props.button}
            </div>
        </div>
    );
};
